import { useParams } from 'react-router-dom';

import useStore from '../../../../../../hooks/useStore';
import { useUpdateRegistration } from '../../../../../registration/useRegistrationForm/useUpdateRegistration';
import { UpdateRegistrationDTO } from '../../../../../../services/types';
import { DetaljeringForm } from '../types';
import { updateDetailingSteps } from '../../../../../../store/registration/actions';
import { Detaljeringssteg } from '../../../../../../types/registration/userInput';

export type DetaljeringFormSubmitPayload = {
  data: DetaljeringForm;
  onSuccess?: (responseData?: UpdateRegistrationDTO) => void;
};

export const useValgfriDetaljeringSubmit = () => {
  const { registrationId } = useParams();
  const { updateRegistration, updateIsLoading, updateError } = useUpdateRegistration(registrationId || '');
  const store = useStore();

  const onSubmit = ({ data, onSuccess }: DetaljeringFormSubmitPayload) => {
    // Valgfri detaljeringssteg may be unchecked after entering data, so we need to update the detailing steps in the redux store
    Object.entries(data).forEach(([step, value]) => {
      store.dispatch(updateDetailingSteps({ step: (step as keyof Detaljeringssteg), value }));
    });

    const userInput = store.getState().register.userInput;

    updateRegistration(
      { registrationId: registrationId, userInput: { ...userInput, detaljeringssteg: data } },
      {
        onSuccess
      }
    );
  };

  return { onSubmit, isLoading: updateIsLoading, updateError };
};
